import { Wrap, StyledPaper } from './styles';

import ItemList from './components/ItemList';

import Icon from '@map/components/Icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';

/**
 * Multiselect
 * 
 * @param {string} name 
 * @param {string} placeholder
 * @param {string} type Radio ou checkbox
 * @param {boolean} onChange
 * @param {number} value
 * @param {Array} data
 * @param {*} avoidMobileBehavior
 * 
 * @returns 
 */
const MultiSelect = ({
  name,
  placeholder,
  type,
  onChange,
  value,
  data,
  avoidMobileBehavior = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  /**
   * Manuseia a mudançca de valores
   *
   * @param {object} e
   */
  const handleChange = (e) => {
    const newValue = e.target.value;
    const checked = e.target.checked;

    if (type === 'radio' && checked && newValue !== value) {
      onChange && onChange(newValue);
      handleClosePopOver();
    } else if (type === 'checkbox') {
      let newArray;
      if (checked && !value.includes(newValue)) {
        newArray = [...value, newValue];
      } else if (!checked) {
        newArray = value.filter((v) => v !== newValue);
      }
      onChange && onChange(newArray);
    }
  };

  /**
   * Método para abertura do PopOver
   *
   * @param {object} event
   */
  const openPopOver = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Método para fechar o PopOver
   */
  const handleClosePopOver = () => {
    setAnchorEl(null);
  };

  return (
    <Wrap avoidMobileBehavior={avoidMobileBehavior}>
      <div className="field" onClick={openPopOver}>
        <span className={`${type === 'radio' && value ? 'filled' : ''}`}>
          {(type === 'radio' &&
            value !== null &&
            data.find((v) => v.value.toString() === value.toString()).label) ||
            placeholder ||
            'Selecione'}
        </span>
        <Icon i="map-chevrondown" />
      </div>
      <div className="mobile-list">
        {data &&
          data.length > 0 &&
          data.map((v, i) => {
            return (
              v.value && (
                <ItemList 
                variant="outlined"
                  label={v.label}
                  type={type}
                  key={i}
                  name={name}
                  index={i}
                  value={v.value.toString()}
                  onChange={handleChange}
                  checked={
                    type === 'radio'
                      ? value !== null
                        ? v.value.toString() === value.toString()
                        : false
                      : value.includes(v.value.toString())
                  }
                />
              )
            );
          })}
      </div>
      <Popper
        style={{ zIndex: '2000' }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        role={undefined}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <ClickAwayListener onClickAway={handleClosePopOver}>
              <StyledPaper
                style={{
                  width: anchorEl && anchorEl.offsetWidth,
                }}
              >
                {data &&
                  data.length > 0 &&
                  data.map((v, i) => {
                    return (
                      v.value && (
                        <ItemList
                          label={v.label}
                          type={type}
                          key={i}
                          name={name}
                          index={i}
                          value={v.value.toString()}
                          onChange={handleChange}
                          checked={
                            type === 'radio'
                              ? value !== null &&
                                v.value.toString() === value.toString()
                              : value.includes(v.value.toString())
                          }
                        />
                      )
                    );
                  })}
              </StyledPaper>
            </ClickAwayListener>
          </Grow>
        )}
      </Popper>
    </Wrap>
  );
};

MultiSelect.properties = {
  ignore: true,
};

export default MultiSelect;
